import { render, staticRenderFns } from "./UserSetteiPage.vue?vue&type=template&id=93999692&scoped=true&"
import script from "./UserSetteiPage.vue?vue&type=script&lang=ts&"
export * from "./UserSetteiPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93999692",
  null
  
)

export default component.exports